import React, { useRef, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { ColorPicker } from "@vtaits/react-color-picker";
import "@vtaits/react-color-picker/index.css";

import Checkbox from "../../Checkbox";

// css
import styles from "../Sidebar.module.scss";

// helper
import {
  OVERLAY,
  DIRECTION,
  OVERLAY_START_FROM,
} from "../../../helpers/constants";

// hooks
import useOutside from "../../../hooks/useOutside";

const Overlay = ({ handleOverlayChange, removeOverlay, overlay, idx }) => {
  const wrapperRef = useRef();
  const colorChange = useRef();

  const [showColorPicker, setColorPicker] = useState(false);
  const [color, setcolor] = useState(overlay.color);

  useOutside(() => {
    setColorPicker(false);
  }, wrapperRef);

  return (
    <tr className="ephemer-item">
      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <div className="d-flex align-items-center bg-transparent justify-content-center gap-10">
          <Button
            className="border-0 p-0 bg-transparent"
            variant="transparent"
            onClick={removeOverlay(idx)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 5 5"
              fill="none"
            >
              <g clip-path="url(#clip0_2_4)">
                <path
                  d="M1.21322 0.756748L2.49989 2.04341L3.77989 0.763415C3.80817 0.733321 3.84222 0.709246 3.88003 0.692635C3.91783 0.676025 3.9586 0.667219 3.99989 0.666748C4.0883 0.666748 4.17308 0.701867 4.23559 0.764379C4.29811 0.826891 4.33322 0.911676 4.33322 1.00008C4.334 1.04095 4.32642 1.08154 4.31094 1.11938C4.29547 1.15721 4.27242 1.19148 4.24322 1.22008L2.94656 2.50008L4.24322 3.79675C4.29816 3.8505 4.33038 3.92328 4.33322 4.00008C4.33322 4.08849 4.29811 4.17327 4.23559 4.23578C4.17308 4.2983 4.0883 4.33341 3.99989 4.33341C3.95741 4.33518 3.91503 4.32809 3.87543 4.31259C3.83584 4.2971 3.7999 4.27354 3.76989 4.24341L2.49989 2.95675L1.21656 4.24008C1.18839 4.26917 1.15475 4.2924 1.11756 4.30842C1.08037 4.32444 1.04038 4.33293 0.999891 4.33341C0.911486 4.33341 0.826701 4.2983 0.764189 4.23578C0.701677 4.17327 0.666558 4.08849 0.666558 4.00008C0.665781 3.95921 0.673363 3.91862 0.68884 3.88079C0.704316 3.84296 0.727361 3.80869 0.756558 3.78008L2.05322 2.50008L0.756558 1.20341C0.70162 1.14967 0.669405 1.07689 0.666558 1.00008C0.666558 0.911676 0.701677 0.826891 0.764189 0.764379C0.826701 0.701867 0.911486 0.666748 0.999891 0.666748C1.07989 0.667748 1.15656 0.700081 1.21322 0.756748Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_2_4">
                  <rect width="5" height="5" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Button>

          <Checkbox
            checked={overlay.enabled}
            onChange={handleOverlayChange(idx, "enabled")}
          />
        </div>
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <Dropdown className={`${styles.dropdown} bg-transparent p-0`}>
          <Dropdown.Toggle
            variant="transparent"
            className="text-dark border fw-sbold text-capitalize"
            id="dropdown-basic"
          >
            {OVERLAY[overlay.overlay] || ""}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              href="#/action-1"
              onClick={() =>
                handleOverlayChange(
                  idx,
                  "overlay"
                )({ target: { value: "degrees" } })
              }
            >
              {OVERLAY.degrees}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <input
          style={{ width: "40px" }}
          type="number"
          step="0.01"
          value={overlay.value}
          onChange={handleOverlayChange(idx, "value")}
        />
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <Dropdown className={`${styles.dropdown} bg-transparent p-0`}>
          <Dropdown.Toggle
            variant="transparent"
            className="text-dark border fw-sbold"
            id="dropdown-basic"
          >
            {DIRECTION[overlay.direction] || ""}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              href="#/action-1"
              onClick={() =>
                handleOverlayChange(
                  idx,
                  "direction"
                )({ target: { value: "clockwise" } })
              }
            >
              {DIRECTION.clockwise}
            </Dropdown.Item>
            <Dropdown.Item
              href="#/action-2"
              onClick={() =>
                handleOverlayChange(
                  idx,
                  "direction"
                )({ target: { value: "counter_clockwise" } })
              }
            >
              {DIRECTION.counter_clockwise}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <Dropdown className={`${styles.dropdown} bg-transparent p-0`}>
          <Dropdown.Toggle
            variant="transparent"
            className="text-dark border fw-sbold"
            id="dropdown-basic"
          >
            {OVERLAY_START_FROM[overlay.startFrom] || ""}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              href="#/action-6"
              onClick={() =>
                handleOverlayChange(
                  idx,
                  "startFrom"
                )({ target: { value: "selection" } })
              }
            >
              {OVERLAY_START_FROM.selection}
            </Dropdown.Item>
            <Dropdown.Item
              href="#/action-5"
              onClick={() =>
                handleOverlayChange(
                  idx,
                  "startFrom"
                )({ target: { value: "fixed" } })
              }
            >
              {OVERLAY_START_FROM.fixed}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <div
          ref={wrapperRef}
          className="color-selection"
          style={{ zIndex: showColorPicker ? 1 : -10 }}
        >
          {showColorPicker && (
            <ColorPicker
              saturationHeight={100}
              value={color}
              onDrag={(color) => {
                setcolor(color);

                if (colorChange.current) {
                  clearTimeout(colorChange.current);
                }

                colorChange.current = setTimeout(
                  () =>
                    handleOverlayChange(
                      idx,
                      "color"
                    )({ target: { value: color } }),
                  200
                );
              }}
            />
          )}
        </div>

        <div
          className="input-group colorpicker-default mb-1"
          title="Using format option"
          style={{ cursor: "pointer" }}
          onClick={() => setColorPicker((prevState) => !prevState)}
        >
          <span className="input-group-append">
            <span className="input-group-text colorpicker-input-addon">
              <i
                style={{
                  height: "16px",
                  width: "16px",
                  background: overlay.color,
                }}
              />
            </span>
          </span>
        </div>
      </td>

      <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
        <Checkbox
          checked={overlay.repeat}
          onChange={handleOverlayChange(idx, "repeat")}
        />
      </td>
    </tr>
  );
};

export default Overlay;
